import React from 'react';
import './Inspection.css';
import InspectionNotes from './components/InspectionNotes';
import InspectionDamages from './components/InspectionDamages';
import { inspectionShape } from './utility/inspection-util';
import InspectionSummary from './components/InspectionSummary';
import InspectionHeader from './components/InspectionHeader';
import InspectionGallery from './components/InspectionGallery';
import InspectionChecklist from './components/InspectionChecklist';


/**
 * A component for displaying a single inspection.
 * @param {object} props.inspection The inspection to be displayed.
 */
function Inspection({ inspection }) {
  return (
    <div className="inspection via-centre">
      <div className="inspection-header" style={{ paddingTop: inspection.externalKey != null ? '0.2em' : undefined }}>
        <InspectionHeader inspection={inspection} />
      </div>
      <div className="inspection-summary">
        <InspectionSummary inspection={inspection} />
      </div>
      <div className="via-centre inspection-width">
        <div className="inspection-features">
          <InspectionChecklist inspection={inspection} position="before_damage" />
          <InspectionDamages
            vehicleDiagramCode={inspection.vehicle.vehicleDiagramCode}
            newDamages={inspection.newDamages}
            existingDamages={inspection.existingDamages}
            externalCustomer={inspection.externalKey != null}
            inspectionCode={inspection.inspectionCode}
            externalKey={inspection.externalKey}
          />
          <InspectionChecklist inspection={inspection} position="after_damage" />
          <InspectionGallery inspection={inspection} />
          <InspectionNotes inspection={inspection} />
        </div>
      </div>
    </div>
  );
}

Inspection.propTypes = {
  inspection: inspectionShape.isRequired,
};

export default Inspection;
